import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { readCliAuthRequest } from "./constants"

/**
 * Brings a signed-in user back to the /cli-auth consent screen when a CLI-auth request is still
 * pending. Mounted inside the authenticated shell, so it catches the cases where the sign-in does
 * not return to /cli-auth on its own (e.g. after "Sign in with a different account").
 *
 * The consent screen is the only place the token is ever handed back.
 */
export function CliAuthHandoff() {
	const navigate = useNavigate()

	useEffect(() => {
		// readCliAuthRequest() re-validates loopback + TTL and purges anything stale, so this only
		// fires while a genuinely pending request is in flight.
		if (readCliAuthRequest()) navigate("/cli-auth", { replace: true })
	}, [navigate])

	return null
}
